import { SET_USER_ROLES } from '../types';
import requestWrapper from '../requestWrapper';
import { setUserRolesEndpoint } from '../../utils/endpoints';

export const setUserRoles = (username, roles) => dispatch => {
  console.log('setUserRoles username: ', username, ' roles: ', roles);
  return requestWrapper(dispatch, {
    actionType: SET_USER_ROLES,
    requestObject: {
      url: setUserRolesEndpoint(),
      method: 'POST',
      responseType: 'json',
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify({ username, roles })
    },
    errorMessage: 'Error updating user roles'
  });
};
